import { getProfileById } from '@core/actions/usersActions.ts'
import { loadingGetProfileId, profileById } from '@core/slice/UsersSlice.ts'
import { useAppDispatch, useAppSelector } from '@core/store/hook.ts'
import Spinner from '@shared/Spinner.tsx'
import { Button } from 'primereact/button'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const DetailProfile = () => {
    const dispatch = useAppDispatch()
    const params = useParams()
    const navigate = useNavigate()
    const profileId = params.id
    const profilById = useAppSelector(profileById)
    const [permissions, setPermissions] = React.useState<string>("")
    const [accesses, setAccesses] = React.useState<string>("")
    const loading = useAppSelector(loadingGetProfileId)
   
    React.useEffect(() => {
      if (profileId) dispatch(getProfileById(profileId));
    }, [dispatch, profileId]);
    
    React.useEffect(()=>{
        if (profilById && profilById.permissions && profilById.accesses) {
          setPermissions(
            profilById.permissions.map((perm) => perm.description).join(", ")
          );
          setAccesses(
            profilById.accesses.map((perm) => perm.description).join(", ")
          );
        }
    },[profilById])

    const handlePrevious = ()=>{
        navigate('/setting/group')
    }
    
  return (
    <div className="w-full column gap-5 bg-white rounded-lg py-8">
      <div className="text-2xl font-semibold text-black ml-8">
        Information sur le groupe
      </div>
      {loading === "loading" ? (
        <div className="flex justify-center py-4">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="w-full flex justify-center">
            <div className="flex flex-col sm:flex-row rounded-lg bg-[#E5E5E5] w-[98%] gap-6 p-6">
              <div className="flex flex-col bg-white w-full rounded-lg p-6 gap-3">
                <div>
                  <span className="text-gray-500 font-semibold">
                    Nom du groupe:{" "}
                  </span>
                  <span className="text-gray-900">{profilById.name}</span>
                </div>
                <div>
                  <span className="text-gray-500 font-semibold">
                    Description:{" "}
                  </span>
                  <span className="text-gray-900">
                    {profilById.description}
                  </span>
                </div>
                <div>
                  <span className="text-gray-500 font-semibold">
                    Permission(s):
                  </span>
                  <span className="text-gray-900"> {permissions}</span>
                </div>
                <div>
                  <span className="text-gray-500 font-semibold">Accès: </span>
                  <span className="text-gray-900">{accesses}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-end mt-3 mr-3">
            <Button
              className="justify-center w-[120px] bg-[#64748B] text-white font-bold py-2 px-4 rounded-md gap-2"
              onClick={handlePrevious}
            >
              Retour
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default DetailProfile
